export default "__VITE_ASSET__DorrOXd3__"